<template>
    <div class="swiper_box_phone">
        <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop">
            <swiper-slide class="slide-1" v-for="(item, index) in bigImg" :key="index">
                <img :src="item" style="height:100%;width:100%" alt="">
            </swiper-slide>
        </swiper>
        <!--<swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs">
            <swiper-slide class="slide" v-for="(item, index) in smallImg" :key="index">
                &lt;!&ndash; <div class="imgItem"> &ndash;&gt;
                <img :src="item" alt="">
                &lt;!&ndash; </div> &ndash;&gt;
            </swiper-slide>
        </swiper>-->
        <div class="swiper-button-prev" slot="button-prev">
            <Icon type="md-arrow-back"/>
        </div>
        <!--左箭头。如果放置在swiper外面，需要自定义样式。-->
        <div class="swiper-button-next"  slot="button-next">
            <Icon type="md-arrow-forward" />
        </div>
        <!--右箭头。如果放置在swiper外面，需要自定义样式。-->
        <!--<div class="projectImg-type">
            <ul>
                <li class="active">房屋</li>
                <li>配套</li>
                <li>设施</li>
                <li>周边环境</li>
            </ul>
        </div>-->
    </div>
</template>

<script>
    import { swiper, swiperSlide } from "vue-awesome-swiper" //导入组件
export default {
    name: "swiperBannerPhone",
    components: {
        swiper: swiper,
        swiperSlide:swiperSlide
    },
    data() {
        return {
            bigImg: [
                require('../assets/images/web/officePic1.jpg'),
                'https://t7.baidu.com/it/u=4138158235,3956816634&fm=193&f=GIF',
                'https://t7.baidu.com/it/u=2942499027,2479446682&fm=193&f=GIF',
                'https://t7.baidu.com/it/u=2610975262,3538281461&fm=193&f=GIF',
            ],
            smallImg: [
                require('../assets/images/web/officePic1s.jpg'),
                require('../assets/images/web/officePic2s.jpg'),
                require('../assets/images/web/officePic3s.jpg'),
                require('../assets/images/web/officePic4s.jpg'),
            ],
            swiperOptionTop: {
                spaceBetween: 2,
                effect: 'fade',
                loop: true,
                loopedSlides: 4,
                prevButton: '.swiper-button-prev',
                nextButton: '.swiper-button-next',
                observer: true,
                observeParents: true,
                grabCursor: true // 抓手
            },
            /*swiperOptionThumbs: {
                loop: true,    //开启无限轮播
                slidesPerView: 4,    //显示几个图片
                spaceBetween: 10,	//小图之间得距离
                direction: 'horizontal',
                // centeredSlides: true, // 设置活动块居中
                grabCursor: true, // 抓手,
                slideToClickedSlide: true,
                watchSlidesVisibility: true,// 防止不可点击
            },*/

        };
    },
    mounted() {
        /*this.$nextTick(() => {
            // 实现swiper双向控制
            const swiperTop = this.$refs.swiperTop.swiper
            const swiperThumbs = this.$refs.swiperThumbs.swiper
            swiperTop.params.control = swiperThumbs
            swiperThumbs.params.control = swiperTop
        })*/
        // console.log(this.imageList);
    },
     watch: {
        imageList: {
            deep: true,
            // handler: function (value) {
            //     console.log(value);
            //     this.bigImg=value;
            //     this.smallImg=value;
            // }
        }
     }
}
</script>

<style lang="less">
.swiper_box_phone {
    height: 200px;
    position: relative;
    /*padding-top:60px;*/

    .swiper-container {
        width: 100%;
        height: 200px;

        .swiper-wrapper {
            height: 100%;
            .swiper-slide {
                width: 100%;
                height: 100%;
                /*background-color: #42b983;*/
                text-align: center;
                border-radius: 5px;

                img {
                    border-radius: 10px;
                }
            }
        }

    }

    .swiper-button-prev,
    .swiper-button-next {
        background-image: none !important;
        background-color: rgba(255, 255, 255, 0.6);
        color: #fff;
        height: 30px;
        width: 30px;
        text-align: center;
        line-height: 30px;
        font-size: 24px;
        border-radius: 15px;
        margin-top: unset;
        bottom: 20px;
        position: absolute;
    }

    .swiper-button-prev {
        left: 10px;
        top: 50%;
        margin-top:-10px;
    }

    .swiper-button-next {
        right: 10px;
        top: 50%;
        margin-top:-10px;
    }

    .projectImg-type {

        position: absolute;
        bottom: 30px;
        z-index: 100;
        width: 400px;
        margin-left: -200px;
        left: 50%;

        ul {
            display: flex;
            flex-flow: row;
            height: 30px;
            line-height: 30px;
            background-color: rgba(255, 255, 255, 0.6);
            border-radius: 15px;
            justify-content: space-around;

            li {
                flex: 1;
                text-align: center;
            }

            li.active {
                background-color: #fff;
                border-radius: 15px;
            }
        }
    }
}
</style>